import Debug from 'debug';
import * as React from 'react';
import { FormSelect } from 'react-bootstrap';
import { Option } from 'gossamer-unified';

const debug = Debug('gfe/fi/Dropdown');

interface DropdownProps {
  className?: string;
  clearOnSelection?: boolean;
  excludeValues?: string[];
  mandatory: boolean;
  onItemSelected: (newValue: string) => void;
  options: Option[];
  validity?: boolean;
  value: string;
}

export const Dropdown = (props: DropdownProps): React.JSX.Element => {
  const [value, setValue] = React.useState<string>(String(props.value) || '');
  const options = props.options
    .filter((opt) => opt.active !== false && (!props.excludeValues || props.excludeValues.indexOf(opt.id) === -1))
    .map((opt) => (
      <option key={opt.id} value={String(opt.id)}>
        {opt.label}
      </option>
    ));
  if (!props.mandatory) {
    options.unshift(
      <option key="*" value="">
        [blank]
      </option>,
    );
  } else if (!props.value) {
    options.unshift(
      <option key="*" value="">
        [choose]
      </option>,
    );
  }
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newVal = event.target.value;
    props.onItemSelected(newVal);
    if (props.clearOnSelection) {
      setValue('');
    } else {
      setValue(newVal);
    }
  };
  return (
    <FormSelect
      className={props.className}
      isInvalid={props.validity === false}
      isValid={props.validity === true}
      onChange={handleChange}
      value={value}
    >
      {options}
    </FormSelect>
  );
};
